@layer chart {
  .wrapper {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: space-between;
    padding: 12px;
    border-bottom: 1px solid var(--border-soft);
    background: var(--surface-hover);
  }

  .assetTicker {
    margin-left: 8px;
    font-size: 0.938rem;
    line-height: 1.25rem;
    font-weight: 400;
    text-transform: uppercase;
  }

  .assetWrapper {
    display: flex;
    align-items: center;
    flex: 1;
    margin-right: 10px;
  }
}
